import { render, staticRenderFns } from "./tab-four.vue?vue&type=template&id=0bbb0410&"
import script from "./tab-four.vue?vue&type=script&lang=ts&"
export * from "./tab-four.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports